import { render, staticRenderFns } from "./LoadingSpinner.vue?vue&type=template&id=bef95e0a&scoped=true&functional=true"
var script = {}
import style0 from "./LoadingSpinner.vue?vue&type=style&index=0&id=bef95e0a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "bef95e0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bef95e0a')) {
      api.createRecord('bef95e0a', component.options)
    } else {
      api.rerender('bef95e0a', component.options)
    }
    module.hot.accept("./LoadingSpinner.vue?vue&type=template&id=bef95e0a&scoped=true&functional=true", function () {
      api.rerender('bef95e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/LoadingSpinner.vue"
export default component.exports